module.exports = __webpack_public_path__ + "img/3-certifications-ml_cut.png";